var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCloudRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.531c0 .74.16 1.44.46 2.06.08.18.17.35.27.51a4.961 4.961 0 0 0 4.27 2.43c1.82 0 3.41-.98 4.27-2.43.1-.16.19-.33.27-.51.3-.62.46-1.32.46-2.06 0-2.76-2.24-5-5-5s-5 2.24-5 5zm5.97 1.83c-.19 0-.38-.07-.53-.22l-.53-.53-.55.55c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.55-.55-.53-.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.53.53.5-.5c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.5.5.53.53c.29.3.29.77 0 1.06-.15.15-.34.22-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.03 18.1c-.36.18-.72-.17-.66-.57.04-.29.06-.59.06-.9 0-3.58-2.92-6.5-6.5-6.5s-6.5 2.92-6.5 6.5c0 .46.05.9.14 1.33.07.35-.2.7-.55.61-3.95-.96-3.97-7.04.45-7.36h.05C2.31 2.29 15.85-1.28 17.4 8.1c4.33.55 6.08 6.32 2.8 9.19-.36.32-.75.59-1.17.81z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCloudRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-cloud-remove.f325f22ee0da4a4a9c887cee13477347.svg";
export { ForwardRef as ReactComponent };